import LoginUtil from 'mptcfe-login-util';
import Util from '@/_utils/util';
const loginUtil = new LoginUtil()

export const getUserInfo = async () => {
    const env = Util.getEnvironment()
    return new Promise((resolve, reject) => {
        loginUtil.checkLogin({
            env: env,
            successFun: (res) => {
                resolve(res)
            },
            failureFun: (error) => {
                reject(error)
            }
        })
    })
}